<div *ngIf="feature" class="feature">
    <img class="image" [src]="imageHelper.getImageLocation(feature.imageToken)" [alt]="feature.altText" />
    <div [ngStyle]="{'color': feature.featureDescriptionFontColor}">{{ feature.description }}</div>
</div>